import styled from "styled-components/macro";

import { space, zIndex } from "shared/styles/constants";

export interface MapContainerProps {
  width?: string;
  height?: string;
}

export const MapContainer = styled.div<MapContainerProps>`
  width: ${({ width }) => width ?? "100%"};
  height: ${({ height }) => height ?? "100%"};

  position: relative;

  border-radius: inherit;
`;

export const OpenMapButton = styled.div`
  position: absolute;
  right: ${space.xs};
  top: ${space.xs};

  z-index: ${zIndex.above};

  @media print {
    display: none;
  }
`;

export const StaticImage = styled.img`
  height: 100%;
  width: 100%;

  object-fit: cover;
  border-radius: inherit;
`;
